// 
import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { BaseClass } from '../../utility/baseClass';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Verticalservice } from '../../main-layout/vertical/verticalservice.service';
import { Utilityservice } from '../../utility/utilityservice.service';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';

@Component({
  selector: 'app-verticalmodal',
  templateUrl: './verticalmodal.component.html',
  styleUrls: ['./verticalmodal.component.css']
})
export class VerticalmodalComponent extends BaseClass implements OnInit {
  CSRFToken = '';
  saveTitle = 'Add';
  requestform: FormGroup;
  onlyView: any;
  isEdit: boolean = false;
  verticalLabel: String = "";

  existingdetails: any = {};
  activeFlag = [
    { labelname: 'Active', value: 'Y' },
    { labelname: 'Inactive', value: 'N' }
  ];
  constructor(
    private verticalservice: Verticalservice,
    private fb: FormBuilder,
    public router: Router,
    public override injector: Injector,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private utilityservice: Utilityservice
  ) {
    super(injector);
    const dataFromParent = this.config.data;
    this.verticalLabel = dataFromParent.labelName; 
    this.gettoken();
    if (dataFromParent?.title === 'Modify Vertical') {
      this.isEdit = true;
      this.saveTitle = 'Modify';

      this.existingdetails = dataFromParent.datas;
    }
  }
  public validation_message: any;
  ngOnInit() {
    this.formInitiliaze();
    if (this.isEdit) {
      this.patchValueForms(this.existingdetails[0]);
    }
    this.validation_message = {
      'name': [
        { type: 'required', message: `${this.verticalLabel} name is required` },
        { type: 'SPACERISTRICTDISALLOWSTARTENDSPACE', message: 'Space is not allowed at the beginning or end' },
        { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
        { type: 'maxlength', message: 'Maximum length exceeded' },
        { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' },
      ],
      activeflag: [{ type: 'required', message: 'Active flag is required.' }],
    };

    this.requestform.get('activeflag')?.valueChanges.subscribe((value) => {
      this.updateActiveFlagOptions(value);
    });

    this.updateActiveFlagOptions(this.requestform.get('activeflag')?.value);
  }



  updateActiveFlagOptions(flagValue: string) {
    if (flagValue === 'Y') {
      this.activeFlag = [
        { labelname: 'Active', value: 'Y' }
      ];
    } else {
      this.activeFlag = [
        { labelname: 'Active', value: 'Y' },
        { labelname: 'Inactive', value: 'N' }
      ];
    }
  }


  patchValueForms(data) {
    this.requestform.patchValue({
      'name': data?.name,
      activeflag: data?.activeflag
    });
  }

  dismiss() {
    Swal.fire({
      title: "Are you sure to close?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "No",
      denyButtonText: `Yes`
    }).then((result) => {
      if (result.isDenied) {
        this.ref.close();
      }
    });
  }

  formInitiliaze() {
    this.requestform = this.fb.group({
      name: ['', Validators.compose([Validators.required,
      Validators.maxLength(100),
      Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICTDISALLOWSTARTENDSPACE),
      Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR)
      ])],
      activeflag: ['Y']
    });
  }

  add() {
    if (this.requestform.invalid) {
      this.validateAllFormFields(this.requestform);
      return; // Exit early if the form is invalid
    }
    if (this.saveTitle === 'Modify') {
      this.modify(this.requestform.value);
    } else {
      Swal.fire({
        title: "Do you want to save the changes?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't Save`
      }).then((value) => {
        if (value.isConfirmed) {
          let data = this.requestform.value;
          data['csrftoken'] = this.CSRFToken 
          this.verticalservice.add(this.requestform.value).subscribe({
            next: (response: any) => {

              if (response?.response === 'exists') {
                Swal.fire(this.verticalLabel + " already exists!", "", "error");
              } else {
                Swal.fire(this.verticalLabel + " added successfully!", "", "success").then(() => {
                  this.ref.close();
                });
              }
            },
            error: (error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: error.error?.error || "An unexpected error occurred.",
                footer: `Error status is: ${error.status}`
              });
            }
          });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
        }
      });

    }
  }

  modify(data: any) {
    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: `Don't Save`
    }).then((value) => {
      if (value.isConfirmed) {
        let data = this.requestform.value;
        data['csrftoken'] = this.CSRFToken
        data.verticalid = this.existingdetails[0].verticalid; 
        this.verticalservice.modify(data).subscribe({
          next: (response: any) => {

            if (response?.response === 'exists') {
              Swal.fire(this.verticalLabel + " already exists!", "", "error");
            } else {
              Swal.fire(this.verticalLabel + " modified successfully!", "", "success").then(() => {
                this.ref.close();
              });
            }
          },
          error: (error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.error?.error || "An unexpected error occurred.",
              footer: `Error status is: ${error.status}`
            });
          }
        });
      } else if (value.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  }

  gettoken() {
    this.CSRFToken = '';
    this.utilityservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    }, error => {
      Swal.fire(error.error.message, '', 'error');
    });
  }
}
